import { strings } from "../../constants/strings";
import { checkSubscription } from "../../helpers/subscriptionProvider";

const subscriptionIsActive = checkSubscription();//useSubscriptionContext();

export const actions = {
  showModal: () => ({
    type: "SHOW_MODAL"
  }),
  hideModal: () => ({
    type: "HIDE_MODAL"
  }),
  showCurriculum: () => ({
    type: "SHOW_CURICULUM",
  }),
  showPowerReader: () => ({
    type: "SHOW_POWER_READER",
  }),
  showPremiumLocked: () => ({
    type: "SHOW_PREMIUM_LOCKED",
  }),
  showLockedModal: () => {
    let txt1
    if(Math.floor(Math.random() * Math.floor(2))) {
      txt1 = strings.Dashboard_popup_all_text2
    } else {
      txt1 = strings.Dashboard_popup_SingleExercise_title2
    }
    return ({
      type: "SHOW_LOCKED_MODAL",
      txt1: txt1,
      txt2: strings.Dashboard_popup_all_text1,
      txt3: strings.Dashboard_popup_all_text2
    })
  },
  initExercises: () => (dispatch, getState) => {
    let state = getState().DASHBOARD
    let exercises = state.exercises
    exercises.map((item) => {
      if (subscriptionIsActive) {
        if (item.accessibility === 'unavailable') {
          item.image = require('assets/images/exercises/' + item.id + '_locked.svg')
        } else {
          item.image = require('assets/images/exercises/' + item.id + '_standard.svg')
          item.accessibility = null
        }
      } else {
        if (item.accessibility === 'unavailable') {
          item.image = require('assets/images/exercises/' + item.id + '_locked_crown.svg')
          item.link = undefined
          item.accessibility = 'premium'
        } else if (item.accessibility === 'premium') {
          item.image = require('assets/images/exercises/' + item.id + '_locked_crown.svg')
          item.link = undefined
        } else {
          item.image = require('assets/images/exercises/' + item.id + '_standard.svg')
        }
      }
    })
    dispatch({
      type: "INIT_EXERCISES",
      exercises: exercises
    })
  }
}
